import { render } from "./ChangeLogView.vue?vue&type=template&id=6566674c"
import script from "./ChangeLogView.vue?vue&type=script&lang=js"
export * from "./ChangeLogView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__